import gql from 'graphql-tag';
import { CreateDocumentFragments } from './create-document.fragments';

export class CreateDocumentQueries {
  static initialDocument = gql`
    query initialDocument($documentId: String!) {
      document(documentId: $documentId) {
        id
        name
        type
        companyName
        expirationDate
        isSigning
        isSelfsign
        value
      }
    }
  `;
  static templateDocument = gql`
    query templateDocumentData($documentId: String!) {
      document(documentId: $documentId) {
        ...templateDocumentFragment
      }
    }
    ${CreateDocumentFragments.templateDocument}
  `;
}
